import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { useStripe, useElements, PaymentElement } from '@stripe/react-stripe-js';
import { getDashboardUrl } from '../../../../../shared/components/domainSupport';

const CheckoutForm = ({ selectedSubscriptionId, newPaymentMethodId }) => {
  const stripe = useStripe();
  const elements = useElements();
  const selectedSeller = useSelector(store => store.sellerSelect);

  const [errorMessage, setErrorMessage] = useState(null);

  const handleSubmit = async (event) => {
    // We don't want to let default form submission happen here,
    // which would refresh the page.
    event.preventDefault();

    if (!stripe || !elements) {
      // Stripe.js has not yet loaded.
      // Make sure to disable form submission until Stripe.js has loaded.
      return;
    }

    const returnUrl = newPaymentMethodId ? `${getDashboardUrl()}/subscription/${selectedSeller.externalCustomerId.concat(selectedSubscriptionId, ':', newPaymentMethodId)}/update` : `${getDashboardUrl()}/subscription/${selectedSeller.externalCustomerId.concat(selectedSubscriptionId)}/complete`;

    const stripeBody = {
      // `Elements` instance that was used to create the Payment Element
      elements,
      confirmParams: {
        return_url: returnUrl,
      },
    }

    const { error } = newPaymentMethodId ? await stripe.confirmSetup(stripeBody) : await stripe.confirmPayment(stripeBody);

    if (error) {
      // This point will only be reached if there is an immediate error when
      // confirming the payment. Show error to your customer (for example, payment
      // details incomplete)
      setErrorMessage(error.message);
    } else {
      // Your customer will be redirected to your `return_url`. For some payment
      // methods like iDEAL, your customer will be redirected to an intermediate
      // site first to authorize the payment, then redirected to the `return_url`.
    }
  };

  return (
    <form onSubmit={handleSubmit}>
      <PaymentElement />
      <br />
      <br />
      <button className="btn btn-primary account__btn" type="submit" disabled={!stripe}>Submit</button>
      {/* Show error message to your customers */}
      {errorMessage && <div>{errorMessage}</div>}
    </form>
  )
};

export default CheckoutForm;
